import logo from './logo.svg';
import './App.css';
import { useEffect, useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './Routes/Routes';
import {io} from 'socket.io-client';
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_SERVER_ADDRESS;
axios.defaults.withCredentials = true;



function App() {


  return (
    <div style={{background:'#F0F3F8'}}>
      <RouterProvider router={router}></RouterProvider>
    </div>
  );
}

export default App;
